import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mrsoftapps-upload-student-record-spinner',
  templateUrl: './upload-student-record-spinner.component.html',
  styleUrls: ['./upload-student-record-spinner.component.scss']
})
export class UploadStudentRecordSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
